import { render, staticRenderFns } from "./PacienteDadosGeraisCadastro.vue?vue&type=template&id=71fea745&scoped=true"
import script from "./PacienteDadosGeraisCadastro.vue?vue&type=script&lang=js"
export * from "./PacienteDadosGeraisCadastro.vue?vue&type=script&lang=js"
import style0 from "./PacienteDadosGeraisCadastro.vue?vue&type=style&index=0&id=71fea745&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fea745",
  null
  
)

export default component.exports